import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/deviantart': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M320 93.2l-98.2 179.1 7.4 9.5h90.8v127.7h-160.9l-13.5 9.2-43.7 84c-0.3 0-8.6 8.6-9.2 9.2h-92.7v-93.2l93.2-179.4-7.4-9.2h-85.8v-127.6h156l13.5-9.2 43.7-84c0.3 0 8.6-8.6 9.2-9.2h97.6v93.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/deviantart.js
// module id = null
// module chunks = 